import { gql } from '@apollo/client'

export default gql(`
    mutation deletePageVersion($id: ID!  $project: String ) {
        deletePageVersion(
          id: $id
          project: $project
        ) {
            id
            isPublished
            publishStartDate
            publishEndDate
        }
    }`
)
